<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { useTranslation } from 'i18next-vue'
import { AxiosError } from 'axios'
import { Button } from 'vant'
import { useRouter } from 'vue-router'
import liff from '@line/liff'
import { useClinicRepository } from '@/repositories/clinicRepo'
import { useAppStore } from '@/stores/AppStore'
import TextDialog from '@/components/TextDialog.vue'

const { t } = useTranslation()

const appStore = useAppStore()
const repository = useClinicRepository(appStore.clinicUUID)
const router = useRouter()

const loading = ref(false)
const alertDialog = ref(false)
const alertText = ref('')

const openAlertDialog = (text: string) => {
  loading.value = false
  alertText.value = text
  alertDialog.value = true
}

const closeLiff = () => {
  liff.closeWindow()
}

const handleNotLogin = () => {
  // redirect to login page
  try {
    router.replace({
      name: 'AccountLink',
      query: {
        c: appStore.clinicUUID,
        liffId: appStore.liffId,
        clinicType: appStore.clinicType,
        channelId: appStore.channelId,
        redirect: 'buycourse',
      },
    })
  } catch (error) {
    console.error(error)
  }
}

const fetchClinicMiniInfo = async () => {
  if (appStore.clinic) return // already have clinic info

  try {
    const clinic = await repository.fetchClinicMiniInfo(appStore.channelId)
    appStore.setClinic(clinic)

    if (!clinic.sell_course_on_line) {
      openAlertDialog(t('redirect.disable_buy_course'))
      return
    }
  } catch (error) {
    console.error('error no clinic found')
    throw new Error('no clinic found')
  }
}

const fetchPatientMiniInfo = async () => {
  if (appStore.patient) return // already have patient info

  try {
    const patient = await repository.fetchPatientMiniInfo()
    appStore.setPatient(patient)
  } catch (error: AxiosError | any) {
    // no patient data in clinic
    console.error(error)
    if (error.isAxiosError && error.response.status === 404) {
      handleNotLogin()
    }
  }
}

const initialize = async () => {
  fetchClinicMiniInfo()
  fetchPatientMiniInfo()
}

onMounted(() => {
  initialize()
})
</script>

<template>
  <TextDialog :show="alertDialog" :text="alertText">
    <template #button>
      <Button style="padding-left: 20px; padding-right: 20px" type="primary" @click="closeLiff">ปิด</Button>
    </template>
  </TextDialog>

  <div>
    <router-view />
  </div>
</template>
